import React from "react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import localeText from "../../../../locale";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { formatPrice } from "../../../../utilities/formatPrice";
import { useLocation } from "react-router-dom";

const ProductRow = ({ item, index, orderItems, quantity }) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const productUrl = isFringeBenefitsPage ? "/fringe-benefit" : "/product";

  const formatPriceFee = (product) => {
    const price = product.priceUnitary;
    const priceWithFEE = price + price * PLATFORM_PRODUCT_FEE;

    return formatPrice(priceWithFEE);
  };
  console.log("----------", item);

  return (
    <div
      className="flex gap-3"
      style={{
        borderBottom:
          orderItems.length > 1 && index < orderItems.length - 1 ? "1px solid #dee2e6" : undefined,
        paddingBottom:
          orderItems.length > 1 && index < orderItems.length - 1 ? "1.5rem" : undefined,
      }}
    >
      <Link
        to={`${productUrl}?id=${isFringeBenefitsPage ? item.fringeBenefit.id : item.product.id}`}
        style={{ height: "110px" }}
      >
        <AdvancedImage
          cldImg={
            item.productVariation && item.productVariation.imageid
              ? cloudinaryInstance
                  .image(item.productVariation.imageid)
                  .resize(fill().width(600).height(600))
                  .format("webp")
              : cloudinaryInstance
                  .image(isFringeBenefitsPage ? item.fringeBenefit.imageid1 : item.product.imageid1)
                  .resize(fill().width(600).height(600))
                  .format("webp")
          }
          height={110}
          className="h-100"
        />
      </Link>
      <div className="flex flex-column">
        <div className="font-semibold" style={{ color: "#344563" }}>
          {isFringeBenefitsPage ? item.fringeBenefit.title : item.product.title}
        </div>
        <div className="flex gap-2 text-xs mt-2" style={{ color: "#7A869A" }}>
          <div>{localeText("quantity")}:</div>
          <div>{item.quantity}</div>
        </div>
        <div
          className="flex gap-2 align-items-end h-full font-bold mb-2"
          style={{ color: "#344563" }}
        >
          {isFringeBenefitsPage ? item.fringeBenefit.currency : item.product.currency}{" "}
          {isFringeBenefitsPage ? item.fringeBenefit.price : formatPriceFee(item)}
        </div>
      </div>
    </div>
  );
};

export default ProductRow;

/*
              {orderItems.map((item, index) => (
                <div
                  key={index}
                  className="flex gap-3"
                  style={{
                    borderBottom:
                      orderItems.length > 1 && index < orderItems.length - 1
                        ? "1px solid #dee2e6"
                        : undefined,
                    paddingBottom:
                      orderItems.length > 1 && index < orderItems.length - 1 ? "1.5rem" : undefined,
                  }}
                >
                  <Link to={`/product?id=${item.product.id}`} style={{ height: "110px" }}>
                    <AdvancedImage
                      cldImg={
                        item.productVariation && item.productVariation.imageid
                          ? cloudinaryInstance
                              .image(item.productVariation.imageid)
                              .resize(fill().width(600).height(600))
                              .format("webp")
                          : cloudinaryInstance
                              .image(item.product.imageid1)
                              .resize(fill().width(600).height(600))
                              .format("webp")
                      }
                      height={110}
                      className="h-100"
                    />
                  </Link>
                  <div className="flex flex-column">
                    <div className="font-semibold" style={{ color: "#344563" }}>
                      {item.product.title}
                    </div>
                    <div className="flex gap-2 text-xs mt-2" style={{ color: "#7A869A" }}>
                      <div>{localeText("quantity")}:</div>
                      <div>{item.quantity}</div>
                    </div>
                    <div
                      className="flex gap-2 align-items-end h-full font-bold mb-2"
                      style={{ color: "#344563" }}
                    >
                      {item.product.currency} {formatPriceFee(item)}
                    </div>
                  </div>
                </div>
              ))}

*/
